<app-page-header [title]="'Brands'" [subtitle]="'Manage brands for SampleStudio'"></app-page-header>
<div class="mb-6">
    <div class="flex justify-between mb-2">
        <p-ifta-label>
            <p-iconfield>
                <p-inputicon class="pi pi-search"></p-inputicon>
                <input pInputText id="brand_search" [(ngModel)]="this.search" (input)="onSearchInputChange()"
                       autocomplete="off"/>
            </p-iconfield>
            <label for="brand_search">Search brand</label>
        </p-ifta-label>
        <p-button label="Add Brand" icon="pi pi-plus" (click)="this.openCreateBrandDialog()" isAdmin
                  [hidden]="false"></p-button>
    </div>
    <div class="border border-gray-300 dark:border-gray-700 p-2 dark:p-0 mb-5 rounded-sm">
        <p-table
                [value]="this.brands"
                [paginator]="true"
                [rows]="this.rows"
                [totalRecords]="this.totalRecords"
                [lazy]="true"
                [first]="this.currentPage * this.rows"
                [loading]="this.loading"
                [rowsPerPageOptions]="[5, 10, 20]"
                (onLazyLoad)="this.onPageChange($event)"
        >
            <ng-template pTemplate="header">
                <tr>
                    <th></th>
                    <th>Name</th>
                    <th>Label</th>
                    <th></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-brand>
                <tr>
                    <td>
                        <img
                                [src]="brand?.image?.content?.preview?.s3url || 'assets/images/no-image.png'"
                                alt="Brand Logo"
                                class="w-10 h-10 object-cover rounded-sm">
                    </td>

                    <td>{{ brand.name }}</td>
                    <td>{{ brand.label }}</td>
                    <td>
                        <div class="flex justify-end">
                            <p-button icon="pi pi-eye" text
                                      pTooltip="View brand"
                                      tooltipPosition="left"
                                      routerLink="/brands/brand/{{brand.id}}"></p-button>

                            <p-button icon="pi pi-pencil" text
                                      isAdmin
                                      pTooltip="Edit brand"
                                      tooltipPosition="left"
                                      (click)="this.editBrand(brand)"></p-button>

                            <p-button icon="pi pi-trash" text
                                      isAdmin
                                      pTooltip="Delete brand"
                                      tooltipPosition="left"
                                      (click)="this.deleteBrand(brand)"
                                      severity="danger"></p-button>
                        </div>

                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>
<div class="flex gap-2 mb-6">
    <p-button label="Export all Brands" icon="pi pi-download" (click)="this.exportBrands()"
              severity="secondary"></p-button>
</div>

<!-- Create Brand Dialog -->
<app-create-brand-dialog
        [(visible)]="this.displayCreateBrandDialog"
        (brandCreated)="this.reloadBrands()"
></app-create-brand-dialog>

<!-- Update Brand Dialog -->
<app-update-brand-dialog
        [(visible)]="this.displayUpdateBrandDialog"
        [brand]="this.selectedBrand"
        (brandUpdated)="this.reloadBrands()"
></app-update-brand-dialog>
